import { Component, ChangeDetectionStrategy, ElementRef, ViewEncapsulation, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFullFadeInScreen } from '../../models/dialogs/dialog-full-fade-in-screen';

const defaultTitle: string = 'Quanto você gostaria de investir em Renda Fixa?';
let defaultValue: number = 20000;

@Component({
    selector: 'tr-overlay-input',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./tr-overlay-input.component.scss'],
    templateUrl: './tr-overlay-input.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TrOverlayInputComponent extends DialogFullFadeInScreen {

    public form: FormGroup;
    public title: string;

    constructor(
        private formBuilder: FormBuilder,
        private elementReference: ElementRef,
        private dialogReference: MatDialogRef<TrOverlayInputComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        super(elementReference);
        this.title = data.title ? data.title : defaultTitle;
        const value = data.initialValue ? data.initialValue : 0;
        defaultValue = data.defaultSimulationValue ? data.defaultSimulationValue : defaultValue;

        this.form = formBuilder.group({
            value: [value, Validators.required],
        });
    }

    public formSubmitHandler(event: Event) {
        event.preventDefault();
        if (this.form.controls.value.value) {
            super.close(this.dialogReference, this.form.controls.value.value);
        } else {
            super.close(this.dialogReference, defaultValue);
        }
    }

    public cancel(event: Event) {
        event.preventDefault();
        super.close(this.dialogReference, defaultValue);
    }

    public onEnterKeyDown(event: Event) {
        this.formSubmitHandler(event);
    }
}
